import countriesJson from '@/pages/dashboard/components/MapEchart/_config/countries.json';

const CHINA_PROVINCE_NAME_MAP: Record<string, string> = {
  北京: '北京市',
  北京市: '北京市',
  Beijing: '北京市',
  天津: '天津市',
  天津市: '天津市',
  Tianjin: '天津市',
  上海: '上海市',
  上海市: '上海市',
  Shanghai: '上海市',
  重庆: '重庆市',
  重庆市: '重庆市',
  Chongqing: '重庆市',
  内蒙古: '内蒙古自治区',
  内蒙古自治区: '内蒙古自治区',
  'Inner Mongolia': '内蒙古自治区',
  广西: '广西壮族自治区',
  广西壮族自治区: '广西壮族自治区',
  Guangxi: '广西壮族自治区',
  西藏: '西藏自治区',
  西藏自治区: '西藏自治区',
  Tibet: '西藏自治区',
  宁夏: '宁夏回族自治区',
  宁夏回族自治区: '宁夏回族自治区',
  Ningxia: '宁夏回族自治区',
  新疆: '新疆维吾尔自治区',
  新疆维吾尔自治区: '新疆维吾尔自治区',
  Xinjiang: '新疆维吾尔自治区',
  香港: '香港特别行政区',
  香港特别行政区: '香港特别行政区',
  'Hong Kong': '香港特别行政区',
  澳门: '澳门特别行政区',
  澳门特别行政区: '澳门特别行政区',
  Macau: '澳门特别行政区',
  Macao: '澳门特别行政区',
  台湾: '台湾省',
  台湾省: '台湾省',
  Taiwan: '台湾省',
  江苏: '江苏省',
  Jiangsu: '江苏省',
  浙江: '浙江省',
  Zhejiang: '浙江省',
  广东: '广东省',
  Guangdong: '广东省',
  山东: '山东省',
  Shandong: '山东省',
  四川: '四川省',
  Sichuan: '四川省',
  河南: '河南省',
  Henan: '河南省',
  湖北: '湖北省',
  Hubei: '湖北省',
  湖南: '湖南省',
  Hunan: '湖南省',
  河北: '河北省',
  Hebei: '河北省',
  山西: '山西省',
  Shanxi: '山西省',
  辽宁: '辽宁省',
  Liaoning: '辽宁省',
  吉林: '吉林省',
  Jilin: '吉林省',
  黑龙江: '黑龙江省',
  Heilongjiang: '黑龙江省',
  安徽: '安徽省',
  Anhui: '安徽省',
  福建: '福建省',
  Fujian: '福建省',
  江西: '江西省',
  Jiangxi: '江西省',
  贵州: '贵州省',
  Guizhou: '贵州省',
  云南: '云南省',
  Yunnan: '云南省',
  陕西: '陕西省',
  Shaanxi: '陕西省',
  甘肃: '甘肃省',
  Gansu: '甘肃省',
  青海: '青海省',
  Qinghai: '青海省',
  海南: '海南省',
  Hainan: '海南省',
};

const ISO2_NAME_GROUPS: Array<[string, string]> = [
  ['cn', 'china 中国 中国大陆'],
  ['us', 'usa unitedstates unitedstatesofamerica 美国'],
  ['gb', 'uk unitedkingdom britain 英国'],
  ['ph', 'philippines 菲律宾'],
  ['id', 'indonesia 印度尼西亚 印尼'],
  ['in', 'india 印度'],
  ['th', 'thailand 泰国'],
  ['jp', 'japan 日本'],
  ['kr', 'korea southkorea 韩国'],
  ['my', 'malaysia 马来西亚'],
  ['sg', 'singapore 新加坡'],
  ['vn', 'vietnam 越南'],
  ['bd', 'bangladesh bengal 孟加拉 孟加拉国'],
  ['pk', 'pakistan 巴基斯坦'],
  ['tr', 'turkey 土耳其'],
  ['ru', 'russianfederation russia 俄罗斯'],
  ['de', 'germany 德国'],
  ['fr', 'france 法国'],
  ['it', 'italy 意大利'],
  ['es', 'spain 西班牙'],
  ['br', 'brazil 巴西'],
  ['mx', 'mexico 墨西哥'],
  ['ca', 'canada 加拿大'],
  ['au', 'australia 澳大利亚'],
  ['ae', 'uae unitedarabemirates 阿联酋'],
  ['sa', 'saudiarabia 沙特阿拉伯'],
  ['iq', 'iraq 伊拉克'],
  ['ir', 'iran 伊朗'],
  ['eg', 'egypt 埃及'],
  ['za', 'southafrica 南非'],
  ['ng', 'nigeria 尼日利亚'],
  ['cd', 'democraticrepublicofthecongo 刚果民主共和国'],
  ['ci', "cotedivoire coted'ivoire 科特迪瓦"],
  ['cz', 'czechrepublic czechia 捷克'],
  ['do', 'dominicanrepublic 多米尼加'],
  ['sy', 'syrianarabrepublic syria 叙利亚'],
  ['tl', 'timorleste timor-leste 东帝汶'],
  ['mk', 'macedonia northmacedonia 北马其顿'],
  ['ps', 'palestine 巴勒斯坦'],
  ['xk', 'kosovo 科索沃'],
  ['tw', 'taiwan 台湾'],
  ['hk', 'hongkong 香港'],
  ['mo', 'macau macao 澳门'],
  ['as', 'americansamoa 美属萨摩亚'],
  ['gf', 'frenchguiana 法属圭亚那'],
  ['gp', 'guadeloupe 瓜德罗普'],
  ['mf', 'collectivitedesaintmartin saintmartin 圣马丁'],
  ['pm', 'saintpierreandmiquelon 圣皮埃尔和密克隆群岛'],
  ['aw', 'aruba 阿鲁巴'],
  ['bm', 'bermuda 百慕大'],
  ['yt', 'mayotte 马约特'],
  ['af', 'afghanistan 阿富汗'],
  ['al', 'albania 阿尔巴尼亚'],
  ['dz', 'algeria 阿尔及利亚'],
  ['ao', 'angola 安哥拉'],
  ['ag', 'antiguaandbarbuda 安提瓜和巴布达'],
  ['ar', 'argentina 阿根廷'],
  ['am', 'armenia 亚美尼亚'],
  ['at', 'austria 奥地利'],
  ['az', 'azerbaijan 阿塞拜疆'],
  ['bh', 'bahrain 巴林'],
  ['bb', 'barbados 巴巴多斯'],
  ['by', 'belarus 白俄罗斯'],
  ['be', 'belgium 比利时'],
  ['bz', 'belize 伯利兹'],
  ['bt', 'bhutan 不丹'],
  ['bo', 'bolivia 玻利维亚'],
  ['ba', 'bosniaandherzegovina 波斯尼亚和黑塞哥维那'],
  ['bn', 'brunei 文莱'],
  ['bg', 'bulgaria 保加利亚'],
  ['bf', 'burkinafaso 布基纳法索'],
  ['kh', 'cambodia 柬埔寨'],
  ['td', 'chad 乍得'],
  ['cl', 'chile 智利'],
  ['co', 'colombia 哥伦比亚'],
  ['cr', 'costarica 哥斯达黎加'],
  ['hr', 'croatia 克罗地亚'],
  ['cu', 'cuba 古巴'],
  ['cy', 'cyprus 塞浦路斯'],
  ['dk', 'denmark 丹麦'],
  ['dm', 'dominica 多米尼克'],
  ['ec', 'ecuador 厄瓜多尔'],
  ['sv', 'elsalvador 萨尔瓦多'],
  ['ee', 'estonia 爱沙尼亚'],
  ['et', 'ethiopia 埃塞俄比亚'],
  ['fj', 'fiji 斐济'],
  ['fi', 'finland 芬兰'],
  ['ga', 'gabon 加蓬'],
  ['gm', 'gambia 冈比亚'],
  ['ge', 'georgia 格鲁吉亚'],
  ['gh', 'ghana 加纳'],
  ['gr', 'greece 希腊'],
  ['gt', 'guatemala 危地马拉'],
  ['gy', 'guyana 圭亚那'],
  ['ht', 'haiti 海地'],
  ['hn', 'honduras 洪都拉斯'],
  ['hu', 'hungary 匈牙利'],
  ['ie', 'ireland 爱尔兰'],
  ['il', 'israel 以色列'],
  ['jm', 'jamaica 牙买加'],
  ['jo', 'jordan 约旦'],
  ['kz', 'kazakhstan 哈萨克斯坦'],
  ['ke', 'kenya 肯尼亚'],
  ['ki', 'kiribati 基里巴斯'],
  ['kw', 'kuwait 科威特'],
  ['kg', 'kyrgyzstan 吉尔吉斯斯坦'],
  ['la', 'laos 老挝'],
  ['lv', 'latvia 拉脱维亚'],
  ['lb', 'lebanon 黎巴嫩'],
  ['lr', 'liberia 利比里亚'],
  ['ly', 'libya 利比亚'],
  ['lt', 'lithuania 立陶宛'],
  ['lu', 'luxembourg 卢森堡'],
  ['mg', 'madagascar 马达加斯加'],
  ['mw', 'malawi 马拉维'],
  ['mv', 'maldives 马尔代夫'],
  ['ml', 'mali 马里'],
  ['mt', 'malta 马耳他'],
  ['mr', 'mauritania 毛里塔尼亚'],
  ['md', 'moldova 摩尔多瓦'],
  ['mn', 'mongolia 蒙古'],
  ['me', 'montenegro 黑山'],
  ['ma', 'morocco 摩洛哥'],
  ['mz', 'mozambique 莫桑比克'],
  ['mm', 'myanmar 缅甸'],
  ['na', 'namibia 纳米比亚'],
  ['np', 'nepal 尼泊尔'],
  ['nl', 'netherlands 荷兰'],
  ['nz', 'newzealand 新西兰'],
  ['ni', 'nicaragua 尼加拉瓜'],
  ['no', 'norway 挪威'],
  ['om', 'oman 阿曼'],
  ['pa', 'panama 巴拿马'],
  ['py', 'paraguay 巴拉圭'],
  ['pe', 'peru 秘鲁'],
  ['pl', 'poland 波兰'],
  ['pt', 'portugal 葡萄牙'],
  ['qa', 'qatar 卡塔尔'],
  ['ro', 'romania 罗马尼亚'],
  ['lc', 'saintlucia 圣卢西亚'],
  ['rs', 'serbia 塞尔维亚'],
  ['sl', 'sierraleone 塞拉利昂'],
  ['sk', 'slovakia 斯洛伐克'],
  ['si', 'slovenia 斯洛文尼亚'],
  ['sb', 'solomonislands 所罗门群岛'],
  ['so', 'somalia 索马里'],
  ['lk', 'srilanka 斯里兰卡'],
  ['sd', 'sudan 苏丹'],
  ['sr', 'suriname 苏里南'],
  ['se', 'sweden 瑞典'],
  ['ch', 'switzerland 瑞士'],
  ['tj', 'tajikistan 塔吉克斯坦'],
  ['tz', 'tanzania 坦桑尼亚'],
  ['tt', 'trinidadandtobago 特立尼达和多巴哥'],
  ['tn', 'tunisia 突尼斯'],
  ['tm', 'turkmenistan 土库曼斯坦'],
  ['ug', 'uganda 乌干达'],
  ['ua', 'ukraine 乌克兰'],
  ['uy', 'uruguay 乌拉圭'],
  ['uz', 'uzbekistan 乌兹别克斯坦'],
  ['ve', 'venezuela 委内瑞拉'],
  ['ye', 'yemen 也门'],
  ['zm', 'zambia 赞比亚'],
];

function normalizeKey(value: string): string {
  return String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9\u4e00-\u9fff]/g, '');
}

const ISO2_BY_NAME: Record<string, string> = ISO2_NAME_GROUPS.reduce(
  (result, [iso, names]) => {
    names.split(/\s+/).forEach((name) => {
      const key = normalizeKey(name);
      if (key) {
        result[key] = iso;
      }
    });
    return result;
  },
  {} as Record<string, string>,
);

function getFlagEnglishName(countryFlag?: string): string {
  const fileName = String(countryFlag || '')
    .split('/')
    .pop() || '';
  return fileName.replace(/\.svg$/i, '').replace(/_/g, ' ');
}

export const isRegionCountryName = (name: string): boolean =>
  String(name || '').includes('地区');

export const isGeoCountryOption = (option?: {
  country_name_ch?: string;
  country_name_en?: string;
  countryFlag?: string;
}): boolean => {
  const name = String(
    option?.country_name_ch || option?.country_name_en || '',
  );
  if (!name || name === '全部' || isRegionCountryName(name)) {
    return false;
  }
  if (/\.com/i.test(name) || name.includes('骨干网')) {
    return false;
  }
  return Boolean(getCountryIso2(option));
};

export const getCountryIso2 = (option?: {
  country_name_ch?: string;
  country_name_en?: string;
  countryFlag?: string;
}): string => {
  const candidates = [
    getFlagEnglishName(option?.countryFlag),
    option?.country_name_en,
    option?.country_name_ch,
  ];
  for (let index = 0; index < candidates.length; index += 1) {
    const iso = ISO2_BY_NAME[normalizeKey(String(candidates[index] || ''))];
    if (iso) {
      return iso;
    }
  }
  return '';
};

export const getGeoFeatureNames = (geoJson: any): Set<string> => {
  const names = new Set<string>();
  (geoJson?.features || []).forEach((feature: any) => {
    const featureName = feature?.properties?.name;
    if (featureName) {
      names.add(String(featureName));
    }
  });
  return names;
};

export const buildFeatureNameIndex = (
  geoJson: any,
): Map<string, string> => {
  const index = new Map<string, string>();
  (geoJson?.features || []).forEach((feature: any) => {
    const props = feature?.properties || {};
    const displayName = String(props.name || props.NAME || '').trim();
    if (!displayName) {
      return;
    }
    const aliases = [
      displayName,
      props['alt-name'],
      props['woe-name'],
      props['cn-name'],
      props.name_zh,
      props.NAME_ZH,
      props.NL_NAME_1,
      CHINA_PROVINCE_NAME_MAP[displayName],
    ]
      .filter(Boolean)
      .flatMap((item) => String(item).split('|'));
    aliases.forEach((alias) => {
      const key = normalizeMatchKey(alias);
      if (key && !index.has(key)) {
        index.set(key, displayName);
      }
    });
  });
  Object.keys(CHINA_PROVINCE_NAME_MAP).forEach((alias) => {
    const mapped = CHINA_PROVINCE_NAME_MAP[alias];
    const displayName =
      index.get(normalizeMatchKey(mapped)) ||
      index.get(normalizeMatchKey(alias));
    if (displayName) {
      const key = normalizeMatchKey(alias);
      if (key && !index.has(key)) {
        index.set(key, displayName);
      }
    }
  });
  return index;
};

function normalizeMatchKey(value: string): string {
  return String(value || '')
    .trim()
    .replace(
      /(维吾尔自治区|壮族自治区|回族自治区|特别行政区|自治区|省|市|州|邦|府|县|大区|专区)$/u,
      '',
    )
    .replace(
      /\s*(province|state|prefecture|region|oblast|county|district|territory|republic)$/i,
      '',
    )
    .toLowerCase()
    .replace(/[^a-z0-9\u4e00-\u9fff]/g, '');
}

export const toMapRegionName = (
  name: string,
  featureNameIndex?: Map<string, string>,
): string => {
  const trimmed = String(name || '').trim();
  if (!trimmed || trimmed === '*' || trimmed === '全部' || trimmed === '综合') {
    return '';
  }
  const candidates = [
    trimmed,
    CHINA_PROVINCE_NAME_MAP[trimmed],
    trimmed.replace(
      /(维吾尔自治区|壮族自治区|回族自治区|特别行政区|自治区|省|市|州|邦|府|县|大区|专区)$/u,
      '',
    ),
  ].filter(Boolean) as string[];
  if (featureNameIndex && featureNameIndex.size) {
    for (let index = 0; index < candidates.length; index += 1) {
      const matched = featureNameIndex.get(
        normalizeMatchKey(candidates[index]),
      );
      if (matched) {
        return matched;
      }
    }
    return '';
  }
  return CHINA_PROVINCE_NAME_MAP[trimmed] || trimmed;
};

export const getCountryMapCenter = (
  nameCh?: string,
  nameEn?: string,
): [number, number] | undefined => {
  const zhMap = (countriesJson as any)?.['zh-CN'] || {};
  const enMap = (countriesJson as any)?.['en-US'] || {};
  const center =
    (nameCh && zhMap[nameCh]) ||
    (nameEn && enMap[nameEn]) ||
    (nameCh && enMap[nameCh]) ||
    (nameEn && zhMap[nameEn]);
  if (!Array.isArray(center) || center.length < 2) {
    return undefined;
  }
  return [Number(center[0]), Number(center[1])];
};

export const getCountryMapZoom = (nameCh?: string): number => {
  const name = String(nameCh || '');
  if (['中国', '美国', '俄罗斯', '加拿大', '巴西', '澳大利亚'].includes(name)) {
    return 3.4;
  }
  return 5.2;
};

const toEchartsGeoJson = (raw: any): any => {
  if (!raw) {
    return raw;
  }
  const features = Array.isArray(raw.features) ? raw.features : [];
  return {
    type: 'FeatureCollection',
    features: features.filter((feature: any) => feature?.geometry),
  };
};

const countryMapPromiseMap: Record<string, Promise<any>> = {};

export const loadCountryMapJson = (iso2: string): Promise<any> => {
  const iso = String(iso2 || '').toLowerCase();
  if (!iso) {
    return Promise.reject(new Error('empty country iso'));
  }
  if (!countryMapPromiseMap[iso]) {
    countryMapPromiseMap[iso] = import(
      /* webpackChunkName: "perf-geojson-[request]" */
      /* webpackInclude: /\.json$/ */
      `../../assets/geojson/${iso}.json`
    )
      .then((mod: any) => {
        const geoJson = toEchartsGeoJson(mod?.default || mod);
        if (!geoJson?.features?.length) {
          throw new Error('empty country map');
        }
        return geoJson;
      })
      .catch((error: Error) => {
        delete countryMapPromiseMap[iso];
        throw error;
      });
  }
  return countryMapPromiseMap[iso];
};
